import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { SkeletonItem } from '@paygreen/paygreen-ui';
import { EditModalIcon } from '../../shared';
import { CardClassic, ErrorBoundary } from '../../../../components';
import UserDisplayBillingData from '../../../user/company/UserDisplayBillingData';
import AddressManagementModal from './AddressManagementModal';

const AddressManagementCard = ({
    t,
    isLoading,
    setIsLoading,
    accountData,
    setAccountData,
    refresh,
}) => (
    <ErrorBoundary>
        <SkeletonItem
            blockHeight="auto"
            colorWab="grey10"
            radiusSize="sm"
            isLoading={isLoading}
        >
            <CardClassic
                isLoading={isLoading}
                title={t('subscription.addressInput')}
                titleSize="md"
                actionIcon={
                    <EditModalIcon title={t('admin.charity.editAddress')}>
                        <AddressManagementModal
                            accountData={accountData}
                            isLoading={isLoading}
                            setIsLoading={setIsLoading}
                            setAccountData={setAccountData}
                            isShop={false}
                            refresh={refresh}
                        />
                    </EditModalIcon>
                }
                isShadowWab={true}
            >
                <UserDisplayBillingData
                    data={accountData?.postalAddress}
                    isLoading={isLoading}
                    hasLabel={false}
                />
            </CardClassic>
        </SkeletonItem>
    </ErrorBoundary>
);

AddressManagementCard.propTypes = {
    isLoading: PropTypes.bool,
    accountData: PropTypes.object,
    refresh: PropTypes.func,
};

AddressManagementCard.defaultProps = {
    isLoading: false,
};

export default withTranslation('common')(AddressManagementCard);
